import { BaseEntity, getCachedSolarSystemEntity } from ".";
import { IGet_universe_structures_structure_id_ok } from "../service/esiclient";
import { getCachedCorporationEntity } from "./CorporationEntityCache";
import { getCachedTypeEntity } from "./TypeEntityCache";

export class StructureEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Structure";
  }

  async toJson(simple?: boolean): Promise<Excel.EntityCellValue> {
    const id = this._id;
    const props: Partial<IGet_universe_structures_structure_id_ok> = this.props;

    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      entity.properties["id"] = {
        type: Excel.CellValueType.formattedNumber,
        basicValue: id,
        numberFormat: "#00",
      };
      // - Data Type
      entity.properties["data_type"] = {
        type: Excel.CellValueType.string,
        basicValue: "Structure",
      };
      if (props.name) entity.properties.name.basicValue = props.name;
      // - Id
      if (props.solar_system_id) {
        const solarSystemEntity = await getCachedSolarSystemEntity(props.solar_system_id);
        if (solarSystemEntity !== null) {
          if (simple !== true) entity.properties["solarsystem"] = await solarSystemEntity.toJson();
        }
      }
      if (props.type_id) {
        if (simple) {
          //this needs to be hand re-made as the base object handling will convert it to a type that's not really needed for this data
          entity.properties["type_id"] = {
            type: Excel.CellValueType.string,
            basicValue: props.type_id.toString(),
          };
          delete entity.properties["type"];
        } else {
          const typeEntity = await getCachedTypeEntity(props.type_id);
          if (typeEntity !== null) {
            entity.properties["type"] = await typeEntity.toJson();
            delete entity.properties["type_id"];
          }
        }
      }
      if (props.owner_id && simple !== true) {
        const corpEntity = await getCachedCorporationEntity(props.owner_id);
        if (corpEntity !== null) {
          entity.properties["owner"] = await corpEntity.toJson();
          delete entity.properties["owner_id"];
        }
      }
      // - Image
    }
    // Layouts
    if (entity.properties?.image) {
      entity.layouts = {
        card: {
          title: { property: "name" },
          mainImage: { property: "image" },
        },
        compact: {
          icon: "Plane",
        },
      };
    } else {
      entity.layouts = {
        card: {
          title: { property: "name" },
        },
        compact: {
          icon: "Plane",
        },
      };
    }

    return entity;
  }
}
